export const convertCountInThousands = (count: number) => {
  return count >= 1000 ? `${parseFloat((count / 1000).toFixed(2))}k` : count;
};

export const sortBySelectionAlpha = (
  array: {
    id: number;
    name: string;
    count: number;
    selected?: boolean;
  }[],
) => {
  const sortedArray = JSON.parse(JSON.stringify(array));
  sortedArray.sort(
    (
      a: { selected: boolean; name: string },
      b: { selected: boolean; name: string },
    ) => {
      const aIsSelected = a.selected || false;
      const bIsSelected = b.selected || false;

      if (bIsSelected !== aIsSelected) {
        return Number(bIsSelected) - Number(aIsSelected);
      } else {
        return a.name.localeCompare(b.name);
      }
    },
  );

  return sortedArray;
};

export const sortBySelectionCount = (
  array: {
    id: number;
    name: string;
    count: number;
    selected?: boolean;
  }[],
) => {
  const sortedArray = JSON.parse(JSON.stringify(array));
  sortedArray.sort(
    (
      a: { selected: boolean; count: number },
      b: { selected: boolean; count: number },
    ) => {
      if (a.selected && !b.selected) {
        return -1;
      } else if (!a.selected && b.selected) {
        return 1;
      } else if (a.count > b.count) {
        return -1;
      } else if (a.count < b.count) {
        return 1;
      } else {
        return 0;
      }
    },
  );

  return sortedArray;
};
